export const MantenimientosActionTypes = {
    API_RESPONSE_SUCCESS: '@@mantenimientos/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@mantenimientos/API_RESPONSE_ERROR',

    GET_MANTENIMIENTO: '@@mantenimientos/GET_MANTENIMIENTO',
    LIST_MANTENIMIENTOS: '@@mantenimientos/LIST_MANTENIMIENTOS',
    // LIST_INVOICES_BY_CLIENT: '@@mantenimientos/LIST_INVOICES_BY_CLIENT',
    CREATE_MANTENIMIENTO:'@@mantenimientos/CREATE_MANTENIMIENTO',
    UPDATE_MANTENIMIENTO:'@@mantenimientos/UPDATE_MANTENIMIENTO',
    DELETE_MANTENIMIENTO:'@@mantenimientos/DELETE_MANTENIMIENTO',

    RESET: '@@mantenimientos/RESET',
};
